// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"801":"1d7be874","814":"737918d6"}[chunkId] + ".chunk.js";
};